import React from 'react'
import { prop } from 'ramda'

import MultiSelectSearchField from '~/components/Fields/MultiSelectSearchField'
import * as API from '~/constants/api'

const getOptionLabel = item => {
  if (item) {
    return prop('number', item)
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('id', item)
    const number = prop('number', item)

    return { id, number }
  }

  return null
}

function ShipmentItemField (props) {
  return (
    <MultiSelectSearchField
      name="objects"
      label="Orders numbers"
      api={API.SALE_ORDER_LIST}
      params={{ limit: 10 }}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      {...props}
    />
  )
}

export default ShipmentItemField
